import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/footer

export const Footer = styled.footer``;
